import { PlayerMetric } from "@/types/metric"

/**
 * Zone 설정 선수별 목록의 표시 순서 (#170 / ERR-022 / 정본 web-g1-f2 "선수 목록 정렬 Default").
 *
 *   1. 토글 On 선수 → 토글 Off 선수
 *   2. 등번호 오름차순 — 숫자로 비교한다 (0 → 3 → 22). 등번호 없는 선수는 뒤로
 *   3. 등번호가 같으면 이름 문자열 오름차순
 *
 * 서버 응답 순서에 의존하지 않고, 등번호가 문자열로 와도 숫자 정렬이 되도록 강제 변환한다.
 * (기획 확인 2026-09-28: Custom 임계값 On 여부는 정렬에 쓰지 않는다)
 */
const toJerseyNumber = (player: PlayerMetric): number => {
  // 타입은 number 지만 실제 응답이 문자열인 경우도 방어한다
  const raw: unknown = player.uniformNumber ?? player.backNumber

  if (raw === null || raw === undefined || raw === "") {
    return Number.POSITIVE_INFINITY
  }

  const parsed = Number(raw)

  return Number.isNaN(parsed) ? Number.POSITIVE_INFINITY : parsed
}

export function comparePlayerMetrics(a: PlayerMetric, b: PlayerMetric): number {
  if (a.active !== b.active) {
    return a.active ? -1 : 1
  }

  const aNumber = toJerseyNumber(a)
  const bNumber = toJerseyNumber(b)
  if (aNumber !== bNumber) {
    return aNumber - bNumber
  }

  return String(a.name ?? "").localeCompare(String(b.name ?? ""))
}

export function sortPlayerMetrics(playerMetrics: PlayerMetric[]): PlayerMetric[] {
  return [...playerMetrics].sort(comparePlayerMetrics)
}
